import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Errors,
  actions,
} from 'react-redux-form';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Link } from 'react-router-dom';

import TradeOrderType from '../Forms/TradeOrderType';
import TradeSecurity from '../Forms/TradeSecurity';
import {
  baseTradeSecurityPath,
  tradeSecurityPath,
  enumSecurityOrderTerms,
  enumSecurityOrderTypes,
} from '../Forms/Schemas/baseRrf';
import BaseDetailScreen from '../BaseDetailScreen';
import Button from '../Button';

import {
  tradeSecurityInfo,
  fetchQuotesSnapQuote,
} from '../../actions';
import Currency, { formatCurrency } from '../Currency';
import { TRADE_TYPE } from '../SecurityTrade';
import { formatQuantity } from '../SecurityDetail/SecurityDetail';
import Tooltip from '../Tooltip';

import { calcFees, calcTotal } from './utils';

import './styles.css';

const Big = require('big.js/big.js');

class UnconnectedTradeSecurity extends Component {
  componentDidMount() {
    const {
      securityId,
    } = this.props;
    this.props.fetchQuotesSnapQuote(securityId, true);
  }
  onSubmit = async () => {
    const {
      tradeSecurityForm,
      tradeOrderTypeForm,
      currentPrice,
      tradeDir,
    } = this.props;
    const { type } = tradeOrderTypeForm;
    const {
      requestedShareAmount,
      limitPrice,
      stopPrice,
      term,
    } = tradeSecurityForm;
    const tradePrice = limitPrice || stopPrice || currentPrice;
    const serviceFee = calcFees(
      tradeDir,
      Number.parseFloat(tradePrice),
      Number.parseFloat(requestedShareAmount),
    );
    const total = calcTotal(
      tradeDir,
      Number.parseFloat(tradePrice),
      Number.parseFloat(requestedShareAmount),
    );
    const data = {
      tradeDir,
      ticker: this.props.securityId,
      type,
      typeLabel: enumSecurityOrderTypes.find(item => item[0] === type)[1],
      ...(!!requestedShareAmount && { requestedShareAmount }),
      ...(!!limitPrice && { limitPrice: Number.parseFloat(limitPrice) }),
      ...(!!stopPrice && { stopPrice: Number.parseFloat(stopPrice) }),
      ...(type !== 'dm' && { term }),
      ...(type !== 'dm' && { termLabel: enumSecurityOrderTerms.find(item => item[0] === term)[1] }),
      serviceFee,
      total,
    };
    await this.props.tradeSecurityInfo(data);
    this.props.onNext();
  }
  render() {
    const {
      backTo,
      cashBalance,
      currentPrice,
      securityQtyHeld,
      tradeOrderTypeForm,
      title,
      tradeSecurityForm,
      tradeDir,
      securityId,
    } = this.props;
    const {
      stopPrice,
      limitPrice,
      requestedShareAmount,
    } = tradeSecurityForm;
    const tradePrice = limitPrice || stopPrice || currentPrice;
    const serviceFee = calcFees(
      tradeDir,
      Number.parseFloat(tradePrice),
      Number.parseFloat(requestedShareAmount),
    );
    const total = calcTotal(
      tradeDir,
      Number.parseFloat(tradePrice),
      Number.parseFloat(requestedShareAmount),
    );
    return (
      <BaseDetailScreen
        backLabel="Security Detail"
        backTo={backTo}
        pageHeading={title}
        pageSubheading={`Cash Available (${formatCurrency(cashBalance)})`}
      >
        <div styleName="tradeForm">
          <TradeOrderType
            tradeOrderTypePath=".tradeOrderType"
            securityId={securityId}
            tradeDir={tradeDir}
          />
          <Form
            onSubmit={this.onSubmit}
            model={tradeSecurityPath}
            validators={{
              '': {
                currentPrice: () => (tradeDir === TRADE_TYPE.BUY ? !!currentPrice : true),
                stopPriceGTMarket: (vals) => {
                  if (vals && vals.stopPrice &&
                    currentPrice && tradeDir === TRADE_TYPE.BUY) {
                    const bigStop = new Big(vals.stopPrice).round(2, 0);
                    const bigCurrent = new Big(currentPrice).round(2, 0);
                    return (
                      bigStop.gt(bigCurrent)
                    );
                  }
                  return true;
                },
                stopPriceLTMarket: (vals) => {
                  if (vals && vals.stopPrice &&
                    currentPrice && tradeDir === TRADE_TYPE.SELL) {
                    const bigStop = new Big(vals.stopPrice).round(2, 0);
                    const bigCurrent = new Big(currentPrice).round(2, 0);
                    return (bigStop.lt(bigCurrent));
                  }
                  return true;
                },
                securityQty: (vals) => {
                  if (vals && vals.requestedShareAmount &&
                    securityQtyHeld && tradeDir === TRADE_TYPE.SELL) {
                    const bigReqAmt = new Big(vals.requestedShareAmount);
                    const bigQtyHeld = new Big(securityQtyHeld);
                    return (bigReqAmt.lte(bigQtyHeld));
                  }
                  return true;
                },
              },
            }}
            disabled={false}
          >
            <div styleName="displayRow">
              <div styleName="marketPriceWithTip">
                <div styleName="formLabelNoMargin">Market Price</div>
                <Tooltip text="Market price fluctuates. The value displayed here may not reflect the most recent trade price for this security." />
              </div>
              <Currency styleName="formValue" amount={currentPrice} />
            </div>
            <div styleName="displayRow">
              <div styleName="formLabelNoMargin">Shares Held</div>
              <div styleName="formValue">{formatQuantity(Number.parseFloat(securityQtyHeld))}</div>
            </div>
            <TradeSecurity
              tradeSecurityPath="."
              orderType={get(tradeOrderTypeForm, 'type', '')}
              securityId={securityId}
              tradeDir={tradeDir}
            />
            <div styleName="breakLineTotal" />
            <div styleName="displayRow">
              <Link to={`/security-trade/${securityId}/${tradeDir}/service-fee-trade`} styleName="formLabelLink">Service Fee</Link>
              <Currency styleName="formValue" amount={serviceFee} />
            </div>
            <div styleName="displayRow">
              <div styleName="formLabelNoMargin">Estimated Total</div>
              <Currency styleName="formValue" amount={total} />
            </div>
            <Errors
              styleName="errorText"
              show={form => form.touched || form.submitted}
              model={tradeSecurityPath}
              messages={{
                  currentPrice: 'Market Price for this security is unavailable. Please try again later.',
                  stopPriceGTMarket: 'Stop Price must be greater than Market Price.',
                  stopPriceLTMarket: 'Stop Price must be less than Market Price.',
                  securityQty: 'Shares must be less than or equal to Shares Held',
                }}
            />
            <div styleName="submitBtn">
              <Button disabled={false} type="submit">Review</Button>
            </div>
          </Form>
        </div>
      </BaseDetailScreen>
    );
  }
}


UnconnectedTradeSecurity.propTypes = {
  title: PropTypes.string,
  backTo: PropTypes.string,
};

UnconnectedTradeSecurity.defaultProps = {
  title: 'Trade Security',
  backTo: '',
};

const mapStateToProps = state => ({
  cashBalance: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceAvailableForT1Trades')),
  tradeSecurityForm: get(state, 'tradeSecurityForm.tradeSecurity'),
  tradeOrderTypeForm: get(state, 'tradeSecurityForm.tradeOrderType'),
});

const mapDispatchToProps = dispatch => ({
  fetchQuotesSnapQuote: (...args) => (dispatch(fetchQuotesSnapQuote(...args))),
  tradeSecurityInfo: (...args) => (dispatch(tradeSecurityInfo(...args))),
  resetTradeSecurityForm: () => (dispatch(actions.reset(`${baseTradeSecurityPath}.tradeSecurity`))),
});


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedTradeSecurity);



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/TradeForm.js